import { FaqSearchIcon, HasSidebarPageWrapper } from '@orcar/common-d2c';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import {
  CS_CENTER_SECTION,
  FAQ_LIST,
  NOTICE_LIST,
} from '@/constants/cs-center';
import FaqCard from './FaqCard';
import NoticeCard from './NoticeCard';
import * as S from './styles';

const CustomerServiceLayout = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const section = searchParams.get('section') || CS_CENTER_SECTION.NOTICE;

  // const [currentSection, setCurrentSection] = useState(
  //   CS_CENTER_SECTION.NOTICE,
  // );
  const [filteredFaqList, setFilteredFaqList] = useState(FAQ_LIST);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const text = ((e.target as HTMLFormElement)[0] as HTMLInputElement).value;
    const filteredFaqs = FAQ_LIST.filter((faq) => faq.query.includes(text));
    setFilteredFaqList(filteredFaqs);
  };

  // useEffect(() => {
  //   if (section) setCurrentSection(section as string);
  // }, [section]);

  return (
    <HasSidebarPageWrapper hasSidebar>
      <S.SideTab>
        <S.Title>고객센터</S.Title>
        <S.Tab
          isActive={section === CS_CENTER_SECTION.NOTICE}
          onClick={() =>
            setSearchParams((params) => {
              params.set('section', CS_CENTER_SECTION.NOTICE);
              return params;
            })
          }
        >
          공지사항
        </S.Tab>
        <S.Tab
          isActive={section === CS_CENTER_SECTION.FAQ}
          onClick={() =>
            setSearchParams((params) => {
              params.set('section', CS_CENTER_SECTION.FAQ);
              return params;
            })
          }
        >
          자주 묻는 질문
        </S.Tab>
        {/* <S.Tab
          isActive={currentSection === CS_CENTER_SECTION.ONE_TO_ONE}
          onClick={() =>
            router.push({
              query: { section: CS_CENTER_SECTION.ONE_TO_ONE },
            })
          }
        >
          1:1 문의하기
        </S.Tab>
        <S.SubTab
          isActive={currentSection === CS_CENTER_SECTION.ONE_TO_ONE && isAsking}
          onClick={() => {
            router.push({
              query: { section: CS_CENTER_SECTION.ONE_TO_ONE, isAsking: true },
            });
          }}
        >
          문의하기
        </S.SubTab>
        <S.SubTab
          isActive={
            currentSection === CS_CENTER_SECTION.ONE_TO_ONE && !isAsking
          }
          onClick={() => {
            router.push({
              query: { section: CS_CENTER_SECTION.ONE_TO_ONE, isAsking: false },
            });
          }}
        >
          문의 내역
        </S.SubTab> */}
      </S.SideTab>

      <S.EventsWrapper>
        <S.CurrentTitle>
          {section === CS_CENTER_SECTION.NOTICE ? (
            '공지사항'
          ) : (
            <>
              <FaqTitleText>자주 묻는 질문(FAQ)</FaqTitleText>
              <FaqInputWrapper>
                <form onSubmit={onSubmit}>
                  <FaqFilterInput placeholder='궁금한 내용을 검색해 보세요.' />

                  <IconWrapper type='submit'>
                    <SearchIcon
                      src={FaqSearchIcon}
                      width={32}
                      height={32}
                      alt='돋보기'
                    />
                  </IconWrapper>
                </form>
              </FaqInputWrapper>
            </>
          )}
        </S.CurrentTitle>

        {section === CS_CENTER_SECTION.FAQ ? (
          <>
            {filteredFaqList.map((faqItem) => {
              return (
                <FaqCard
                  key={faqItem.query}
                  query={faqItem.query}
                  answer={faqItem.answer}
                />
              );
            })}
          </>
        ) : section === CS_CENTER_SECTION.NOTICE ? (
          <>
            {NOTICE_LIST.map((noticeItem) => {
              return (
                <NoticeCard
                  key={noticeItem.title}
                  title={noticeItem.title}
                  date={noticeItem.date}
                  detail={noticeItem.detail}
                />
              );
            })}
          </>
        ) : (
          // ) : currentSection === CS_CENTER_SECTION.ONE_TO_ONE && isAsking ? (
          //   <OneToOneAskForm />
          // ) : (
          //   <>
          //     <OneToOneHistoryCard isCompleted={true} />
          //     <OneToOneHistoryCard isCompleted={false} />
          //     <OneToOneHistoryCard isCompleted={true} />
          //     <EmptyHistory>문의 내역이 없습니다.</EmptyHistory>
          //   </>
          <></>
        )}
      </S.EventsWrapper>
    </HasSidebarPageWrapper>
  );
};

export default CustomerServiceLayout;

const FaqTitleText = styled.div``;

const FaqInputWrapper = styled.div`
  width: 300px;
  height: 40px;
`;

const FaqFilterInput = styled.input`
  width: 300px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
  background: transparent;
  padding: 12px 6px 11px 16px;
  outline: none;
  background-color: rgba(255, 255, 255, 1);
  font-size: 14px;
`;

const IconWrapper = styled.button`
  width: 32px;
  height: 32px;
  position: relative;
  bottom: 36px;
  left: 262px;
`;

const SearchIcon = styled.img``;

const OneToOneTitle = styled.div``;

const OneToOneSubText = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.FONT.B1};
  font-size: 14px;
  line-height: 16.71px;
  color: ${({ theme }) => theme.COLOR.GREY_02};
`;

// const EmptyHistory = styled.div`
//   width: 792px;
//   height: 141px;
//   background-color: ${({ theme }) => theme.COLOR.WHITE};
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   ${({ theme }) => theme.FONT.H4};
//   color: ${({ theme }) => theme.COLOR.GREY_01};
// `;
